module.exports = __webpack_public_path__ + "img/ml.6a716494.svg";